import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  loginButton: {
    id: 'login.facebook.button',
    description: 'Login button for Facebook login',
    defaultMessage: 'Kirjaudu Facebookilla',
  },
});
